import { Copy } from 'lucide-react';
import React, { ReactNode, useState } from 'react'

interface DetailInfoProps {
    title: string;
    value?: string | number;
    isCopy?: boolean;
    children?: ReactNode
}

const DetailInfo = ({ title, value, isCopy = false, children }: DetailInfoProps) => {
    const [copied, setCopied] = useState<string | null>(null)
    const handleCopy = (value: string) => {
        navigator.clipboard?.writeText(String(value ?? '')).catch(() => undefined)
        setCopied(value)
        window.setTimeout(() => setCopied((prev) => (prev === value ? null : prev)), 1500)
    }

    return (
        <div className='w-full items-start flex flex-col gap-1 body1medium'>
            <p className='text-text-grey'>{title}</p>
            <span className='text-black gap-1 inline-flex items-center max-w-full min-w-0'>
                <span className='truncate min-w-0'>{value}</span>
                {isCopy && (
                    <button
                        onClick={() => handleCopy(value as string)}
                        type='button'
                        className="shrink-0 inline-flex items-center gap-1 text-text-blue-100 transition hover:opacity-80">

                        <Copy size={14} strokeWidth={1.8} className='text-text-blue-100' />
                        {copied && (
                            <span>tersalin</span>
                        )}
                    </button>

                )}
            </span>
            {children}
        </div>
    )
}

export default DetailInfo
